<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <div
        class="indicator"
        v-bind="attrs"
        style="height: 100%"
        v-on="on"
      >
        <div v-if="loading" class="indicator-loader-wrapper">
          <loader />
        </div>
        <template v-else>
          <div style="z-index: 2" class="mr-5">
            <div class="indicator-title">
              <slot name="title" :title="title">
                {{ title }}
              </slot>
            </div>
            <div class="d-inline-block">
              <div
                class="indicator-main-value"
                :style="{ color: mainValueColor }"
              >
                <slot name="main-value" :mainValue="mainValue">
                  {{ mainValue }}
                </slot>
              </div>
              <template v-if="!hideSubValue">
                <hr class="indicator-separator" />
                <div class="indicator-sub-value">
                  <slot name="sub-value" :subValue="subValue">
                    {{ subValue }}
                  </slot>
                </div>
              </template>
            </div>
          </div>
          <slot name="icon" :icon="icon">
            <img class="indicator-icon" :src="icon" alt="icon" />
          </slot>
        </template>
      </div>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'IndicatorItem',
    props: {
      title: String,
      mainValue: [String, Number],
      tooltipText: String,
      mainValueColor: {
        type: String,
        default: '#FF9D00',
      },
      icon: String,
      subValue: {
        type: [String, Number],
        default: () => null,
      },
      hideSubValue: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style lang="less" scoped>
.indicator {
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 8px 15px;
  background-color: #f1f3f6;
  height: 100%;
  position: relative;

  &-loader-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  &-title {
    color: #949191;
    font-size: 12px;
  }

  &-main-value {
    font-size: 22px;
    font-weight: bold;
    white-space: nowrap;
  }

  &-sub-value {
    font-size: 16px;
    color: #c2c6d6;
  }

  &-separator {
    color: #c4cdd9;
  }

  &-icon {
    position: absolute;
    right: 15px;
    opacity: 0.4;
    max-height: 50px;
  }
}
</style>
<script setup lang="ts">
import Loader from '@/components/loader/Loader.vue'
</script>
